import { useDispatch, useSelector } from 'react-redux';
import GraphViewControlBar from '../GraphViewControlBar.tsx';
import type { GraphViewOption } from '../GraphViewControlBar.tsx';
import { selectAssetCountByManufacturerView, setAssetByManufacturerView } from '../../../../redux/slices/summaryGraphViewSlice.ts';
import { ChartType } from '../../../../pages/Summary/Components/Charts/ChartTypes.ts';

/**
 * View options for asset by manufacturer charts
 */
export const assetByManufacturerViewOptions: GraphViewOption[] = [
  { id: 'totalAssets', label: 'Total Assets' },
  { id: 'totalPurchasedValue', label: 'Total Purchased Value' },
];

/**
 * AssetByManufacturerType - Component for rendering the GraphViewControlBar with
 * asset by manufacturer view options
*/
const AssetByManufacturerType = () => {
  const dispatch = useDispatch();

  // Get the currently selected view from Redux store
  const selectedView = useSelector(selectAssetCountByManufacturerView);

  // Handler for when user changes the view
  const handleViewChange = (newView: GraphViewOption) => {
    dispatch(setAssetByManufacturerView(newView));
  };

  return (
    <GraphViewControlBar
        viewAll={true}
        chartType={ChartType.ASSET_MANUFACTURER}
        dropdown={{
        options: assetByManufacturerViewOptions,
        selection: selectedView || assetByManufacturerViewOptions[0],
        onChange: handleViewChange
      }}
    />
  );
};

export default AssetByManufacturerType;
